import { alpha } from "@mui/material";
import { menuItemHeight } from "../../component/mui/menu/interface";

export default function Menu(theme: any) {
  return {
    MuiMenu: {
      styleOverrides: {
        root: {
          "& .MuiMenuItem-root.Mui-selected": {
            backgroundColor: alpha(theme.palette.background.default, 1),
          },
          "& .MuiMenuItem-root": {
            height: menuItemHeight,
            borderRadius: 0,
            padding: "0px 0px !important",
          },
        },
      },
    },
  };
}
